var _circle, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4398,
    cy: 24.0218,
    r: 23.7132,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4412 7.98633L38.4024 13.1449H10.4801L24.4412 7.98633Z",
    fill: "#A94E76"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4727,
    y: 14.6973,
    width: 27.8777,
    height: 3.20313,
    fill: "#A94E76"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5039,
    y: 34.2285,
    width: 27.8777,
    height: 3.20313,
    fill: "#A94E76"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 19.0547,
    width: 14.017,
    height: 2.663,
    transform: "rotate(90 16.25 19.0547)",
    fill: "#A94E76"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5742,
    y: 19.0547,
    width: 14.017,
    height: 2.663,
    transform: "rotate(90 22.5742 19.0547)",
    fill: "#A94E76"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8984,
    y: 19.0547,
    width: 14.017,
    height: 2.663,
    transform: "rotate(90 28.8984 19.0547)",
    fill: "#A94E76"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 19.0547,
    width: 14.017,
    height: 2.663,
    transform: "rotate(90 35.2227 19.0547)",
    fill: "#A94E76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.2620bec4f13ee29bc2a8c9b58d6da1d9.svg";
export { ForwardRef as ReactComponent };